import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=3ca33334&"
import script from "./PersonalCenter.vue?vue&type=script&lang=js&"
export * from "./PersonalCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports